import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    loading: translate({
      id: 'orders.smsNotifications.loading',
    }),

    notificationsListFailureTitle: translate({
      id: 'orders.notificationsList.failure.title',
    }),

    notificationsListFailureDescription: translate({
      id: 'orders.notificationsList.failure.description',
    }),
  }))

  return api
}
